export const STUDY_LEVEL_LOGS_DROPDOWN = [
  { label: "Job Id", value: "job_id" },
  { label: "Study Time", value: "study_time" },
  { label: "Modality", value: "modality" },
  { label: "Study Instance UID", value: "study_instance_uid" },
  { label: "Patient ID", value: "patient_id" },
  { label: "Study Description", value: "study_desc" },
  { label: "Instance Count", value: "instances_count" },
  { label: "Receive Time", value: "created_on" },
  { label: "TAT", value: "tat" },
  { label: "Accession Number", value: "accession_number" },
  { label: "Status", value: "status" },
];

export const SOP_LEVEL_LOGS_DROPDOWN = [
  { label: "Modality", value: "modality" },
  { label: "Series Description", value: "series_desc" },
  { label: "Study Instance UID", value: "study_instance_uid" },
  { label: "Series Instance UID", value: "series_instance_uid" },
  { label: "SOP Instance UID", value: "sop_instance_uid" },
  { label: "Body Part", value: "body_part_examined" },
  { label: "Status", value: "status" },
  { label: "Multiframe", value: "multiframe" },
  { label: "Receive Time", value: "created_on" },
  { label: "Last Updated", value: "last_updated_at" },
];

export const ROUTER_CONFIG_DROPDOWN = [
  { label: "Config Name", value: "config_name" },
  // { label: "Time Interval", value: "time_interval" },
  { label: "PACS Config", value: "pacs_config_data" },
  { label: "Platform", value: "platform_data" },
  { label: "Filter", value: "filter_data" },
  { label: "Anon Protocol", value: "anon_protocol_data" },
];

export const NODES_DROPDOWN = [
  { label: "Name", value: "name" },
  { label: "Version", value: "version" },
  { label: "Port", value: "port" },
  { label: "Ip", value: "ip" },
];

export const DROPDOWN_PACS_DATA = [
  { label: "Name", value: "name" },
  { label: "Ae Title", value: "ae_title" },
  { label: "Port", value: "port" },
  { label: "Ip Address", value: "ip" },
];

export const DROPDOWN_FILTERS = [{ label: "Name", value: "name" }];

export const DROPDOWN_PLATFORM_DATA = [
  { label: "Name", value: "name" },
  { label: "Ip Address", value: "ip" },
  { label: "Dataset ID", value: "dataset_id" },
  { label: "RPC URL", value: "rpc_url" },
  { label: "Username", value: "platform_user_id" },
];

export const DROPDOWN_QRSTUDIES_DATA = [
  { label: "Identifier Type", value: "unique_identifier_type" },
  { label: "Unique Identifier", value: "unique_identifier_value" },
  { label: "Patient Name", value: "patient_name" },
  { label: "Instances", value: "instances" },
  { label: "Pushed Instances", value: "received_instances" },
  { label: "Router Configuration", value: "router_config_name" },

]

export const OPERATIONS_DROPDOWN = [
  { label: "Filter", value: "Filter" },
  { label: "QR", value: "qr" },
];
export const UID_DROPDOWN = [
  { label: "Accession Number", value: "Accession Number" },
  { label: "Study Instance UID", value: "Study Instance UID" },
];
export const STUDY_LOGS_DATE_FILTER = [
  { label: "Receive Time", value: "created_on" },
  { label: "Result Push To PACS", value: "results_pushed_to_pacs" },
];
export const SOP_LOGS_DATE_FILTER = [
  { label: "Receive Time", value: "created_on" },
];
export const DATE_RANGE = [
  {
    value: "today",
    label: "Today",
  },
  {
    value: "yesterday",
    label: "Yesterday",
  },
  {
    value: "last_week",
    label: "Last Week",
  },
  {
    value: "last_month",
    label: "Last Month",
  },
  {
    value: "last_year",
    label: "Last Year",
  },
  {
    value: "Custom_Date",
    label: "Custom Date",
  },
];

export const DICOM_MODALITIES = [
  { value: "CR", label: "CR" }, // Computed Radiography
  { value: "MG", label: "MG" }, // Mammography
  { value: "CT", label: "CT" }, // Computed Tomography
  { value: "SEG", label: "SEG" }, // Segmentation
  { value: "DR", label: "DR" }, // Digital Radiography
  { value: "XA", label: "XA" }, // X-Ray Angiography
  { value: "DX", label: "DX" }, // Digital Radiography
  { value: "ECG", label: "ECG" }, // Electrocardiography
  { value: "US", label: "US" }, // Ultrasound
  { value: "ES", label: "ES" }, // Endoscopy
  { value: "OT", label: "OT" }, // Other
  { value: "PT", label: "PT" }, // Positron Emission Tomography (PET)
  { value: "SR", label: "SR" }, // Structured Report
  { value: "SM", label: "SM" }, // Slide Microscopy
  { value: "MR", label: "MR" }, // Magnetic Resonance
  { value: "NM", label: "NM" }, // Nuclear Medicine
  { value: "RF", label: "RF" }, // Radio Fluoroscopy
  { value: "XC", label: "XC" }, // External Camera Photography
  { value: "IO", label: "IO" }, // Intra-Oral Radiography
  { value: "IVOCT", label: "IVOCT" }, // Intravascular Optical Coherence Tomography
  { value: "OP", label: "OP" }, // Ophthalmic Photography
  { value: "PX", label: "PX" }, // Panoramic X-Ray
  { value: "RG", label: "RG" }, // Radiographic Imaging
  { value: "RTDOSE", label: "RTDOSE" }, // Radiotherapy Dose
  { value: "RTIMAGE", label: "RTIMAGE" }, // Radiotherapy Image
  { value: "RTPLAN", label: "RTPLAN" }, // Radiotherapy Plan
  { value: "RTRECORD", label: "RTRECORD" }, // RT Treatment Record
  { value: "RTSTRUCT", label: "RTSTRUCT" }, // Radiotherapy Structure Set
];
